var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 6.7C9.7 6.7 39.4 5.7 44.7 6.7C44.7 6.7 45.9 52.4 44.7 53.3C44.7 53.3 13.8 54.1 9.7 53.3C7.4 52.8 9.7 6.7 9.7 6.7Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 16.2H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 21.8H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 27.4H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 33H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 38.6H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 44.2H14.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8543 26.1841L46.0965 23.4264L31.4594 38.0635L34.2172 40.8212L48.8543 26.1841Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7212 21.451L51.0647 22.7945C51.4889 23.2188 51.4889 23.7845 51.0647 24.2087L50.2161 25.0573L47.4584 22.2996L48.307 21.451C48.7312 21.0268 49.2969 21.0268 49.7212 21.451Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 44.6L32.7 42.3L29.9 39.5L27.6 44.6Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.a825a7081f567f8e6c8a91b7f2019444.svg";
export { ForwardRef as ReactComponent };